import React, { Component } from 'react';
import { Navbar, Image } from 'react-bootstrap';
import LogoImage from '../../Images/logo_wirebit.png';

class NavbarEmptyIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  redirectLanding() {
    this.props.data.data.history.push("/");
  }

  render() {
    return (
      <div className="container_resize">
        <Navbar className="navbar_container_extern" fixed="top" expand="lg">
          <Navbar.Brand onClick={() => { this.redirectLanding() }} style={{ cursor: "pointer" }}>
            <Image src={LogoImage} style={{ width: 100 }} />
          </Navbar.Brand>
        </Navbar>
      </div>
    );
  }
} export default NavbarEmptyIndex;